if (!customElements.get("richtext-video")) {
  customElements.define(
    "richtext-video",
    class RichtextVideo extends HTMLElement {
      constructor() {
        super();

        this.video = this.querySelector("video");

        this.video.addEventListener("mouseover", this.playVideo.bind(this));
        this.video.addEventListener("mouseout", this.pauseVideo.bind(this));
      }

      playVideo() {
        this.video.play();
      }

      pauseVideo() {
        this.video.pause();
      }
    },
  );
}
